var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-2 clickable brand-group-card-hover-shadow",class:{
      'grey--text text--darken-3': !_vm.selected,
      'msr--text msr--bold-outline elevation-12': _vm.selected,
    },attrs:{"flat":"","title":_vm.group.name,"width":_vm.cardWidth,"height":_vm.cardHeight},nativeOn:{"click":function($event){_vm.$emit('toggled')}}},[_c('v-layout',{attrs:{"column":"","fill-height":""}},[_c('v-layout',{staticClass:"pt-1 px-1"},[(_vm.group.logo_image_url)?_c('v-img',{staticClass:"background-size-contain",attrs:{"src":_vm.group.logo_image_url,"aspect-ratio":_vm.imageMaxWidth / _vm.imageMaxHeight}}):_vm._e()],1),_vm._v(" "),_c('v-card-title',{staticClass:"px-2 pb-2",class:{
          'subheading pt-2': _vm.$vuetify.breakpoint.smAndUp,
          'pt-1': _vm.$vuetify.breakpoint.xsOnly,
        },staticStyle:{"justify-content":"center"},style:({'max-width': _vm.cardWidth + 'px'})},[_c('span',{class:{bold: _vm.selected}},[_vm._v(_vm._s(_vm.group.name))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BrandGroupCard.vue?vue&type=template&id=3deb9d39&scoped=true&
// module id = 1901
// module chunks = 5